import { Panel } from "primereact/panel";
import { formatDate, formatDateTime } from "../utils/FormateDateTime";
import {
  getColor,
  sequenceTableTemplate,
  statusTemplate,
} from "../utils/squenceTableNo";
import { Checkbox } from "primereact/checkbox";
import { fetchData } from "../helpers/fetchData";
import toast from "react-hot-toast";
import CustomChip from "../shared/CustomChip";

export const orderDetailsList = (orderDetails, t) => {
  return [
    {
      label: t("OrderNumber"),
      text: orderDetails?.order_no || "--",
    },
    {
      label: t("OrderDate"),
      text: formatDateTime(orderDetails?.order_date) || "--",
    },
    {
      label: t("OrderStatus"),
      text: orderDetails?.order_status || "--",
    },
    {
      label: t("PaymentMethod"),
      text: orderDetails?.payment_method || "--",
    },
    {
      label: t("PatientName"),
      text: orderDetails?.patient?.full_name || "--",
    },
    {
      label: t("Nationality"),
      text: orderDetails?.patient?.nationality || "--",
    },
    {
      label: t("BeneficiaryType"),
      text: orderDetails?.patient?.beneficiary_type || "--",
    },
    {
      label: t("Practitioner"),
      text: orderDetails?.practitioner?.name || "--",
    },
    {
      label: t("Practitioner Department"),
      text: orderDetails?.practitioner?.department?.name_en || "--",
    },
    {
      label: t("Practitioner Speciality"),
      text: orderDetails?.practitioner?.speciality?.name_en || "--",
    },
    // {
    //   label: t("Address"),
    //   text: orderDetails?.patient?.address || "--",
    // },
    {
      label: t("TotalNumberOfSessions"),
      text: orderDetails?.number_of_sessions ?? "--",
    },
    {
      label: t("TakenSessions"),
      text: orderDetails?.taken_sessions ?? "0",
    },
    {
      label: t("RemainSessions"),
      text: orderDetails?.left_sessions ?? "--",
    },
  ];
};
export const insurancePlansColumsDataDetail = (
  t,
  setCheckEligibilityLoading,
  patientDetails,
  navigate,
  hasEligibilityStatus = false
) => [
    {
      field: "payer_name",
      header: t("PayerName"),
      headerCellClass: "!bg-gray-200",
    },
    {
      field: "expiry_date",
      header: t("ExpiryDate"),
      body: (rowData) => formatDate(rowData?.expiry_date),
      headerCellClass: "!bg-gray-200",
    },
    {
      field: "member_card_id",
      header: t("MemberCardID"),
      headerCellClass: "!bg-gray-200",
    },
    {
      field: "policy_number",
      header: t("PolicyNumber"),
      headerCellClass: "!bg-gray-200",
    },
    {
      field: "policy_holder",
      header: t("PolicyHolder"),
      headerCellClass: "!bg-gray-200",
    },
    {
      field: "relation_with_subscriber",
      header: t("RelationwithSubscriber"),
      headerCellClass: "!bg-gray-200",
    },
    {
      field: "coverage_type",
      header: t("CoverageType"),
      headerCellClass: "!bg-gray-200",
    },
    {
      field: "is_primary",
      header: t("Primary"),
      headerCellClass: "!bg-gray-200",
      body: (rowData) => (
        <div>
          <Checkbox
            onChange={async (e) => {
              setCheckEligibilityLoading(true);
              try {
                const response = await fetchData(
                  "POST",
                  "/v3/patient/setPrimaryInsurance",
                  {
                    patient_id: patientDetails?.patient_id,
                    insurance_plan_id: rowData?.insurance_plan_id,
                  }
                );
                if (
                  response?.message ==
                  "Primary insurance plan updated successfully"
                ) {
                  toast.success(response.message);
                  navigate("/beneficiary");
                }
              } catch (err) {
                console.error("Error setting primary insurance:", err);
                toast.error("Failed to update primary insurance");
              } finally {
                setCheckEligibilityLoading(false);
              }
            }}
            checked={rowData.is_primary}
          />
        </div>
      ),
    },
    ...(hasEligibilityStatus
      ? [
        {
          field: "eligiblity_status",
          header: t("Eligibility Status"),
          headerCellClass: "!bg-gray-200",
          body: (rowData) => (
            <CustomChip
              label={rowData.eligiblity_status || "---"}
              chipType={
                rowData.eligiblity_status?.toLowerCase() == "active" ||
                  rowData.eligiblity_status?.toLowerCase() == "eligible"
                  ? "success"
                  : "danger"
              }
              className="h-[22px] rounded-full px-2 py-1"
            />
          ),
        },
        {
          field: "disposition",
          header: t("Disposition"),
          headerCellClass: "!bg-gray-200",
        },
      ]
      : []),
  ];

export const insurancePlansColumsData = (t) => [
  {
    field: "payer_name",
    header: t("PayerName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "expiry_date",
    header: t("ExpiryDate"),
    body: (rowData) => formatDate(rowData?.expiry_date),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "member_card_id",
    header: t("MemberCardID"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "policy_number",
    header: t("PolicyNumber"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "policy_holder",
    header: t("PolicyHolder"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "relation_with_subscriber",
    header: t("RelationwithSubscriber"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "coverage_type",
    header: t("CoverageType"),
    headerCellClass: "!bg-gray-200",
  },
];

export const itemsColumnsData = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "item_name",
    header: t("Name"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "unit_price",
    header: t("UnitPrice"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "quantity",
    header: t("Quantity"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "item_type",
    header: t("Type"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "standard_code",
    header: t("StandardCode"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "non_standard_code",
    header: t("NonStandardCode"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "standard_description",
    header: t("StandardDescription"),
    headerCellClass: "!bg-gray-200",
  },
];

export const reportsBodyData = [
  { name: "View Vital Signs Report" },
  { name: "View Home Healthcare Patient Progress Notes" },
];

export const ordersTableColumnsData = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    field: "order_date",
    header: t("OrderDate"),
    body: (rowData) => formatDateTime(rowData?.order_date),
  },
  {
    field: "order_no",
    header: t("OrderNo"),
  },
  {
    field: "patient.full_name",
    header: t("PatientName"),
  },
  {
    field: "patient.beneficiary_type",
    header: t("BeneficiaryType"),
  },
  {
    field: "patient.nationality",
    header: t("Nationality"),
  },
  {
    field: "practitioner.name",
    header: t("Practitioner"),
  },
  {
    field: "payment_method",
    header: t("PaymentMethod"),
  },
  {
    field: "number_of_sessions",
    header: t("NumberOfSessions"),
  },
  {
    field: "left_sessions",
    header: t("RemainingSessions"),
  },
  {
    body: (row) => {
      let status = { status: row?.order_status };
      return row?.order_status ? statusTemplate(status) : "";
    },
    header: t("Status"),
  },
];

export const rowExpansionInsuranceTemplate = (data, t) => {
  let rowData = [
    {
      label: t("PatientShare"),
      text: data?.patient_share,
    },
    {
      label: t("MaxLimit"),
      text: data?.max_limit,
    },
    {
      label: t("IssueDate"),
      text: formatDateTime(data?.issue_date),
    },
    {
      label: t("IsPrimary"),
      text: data?.is_primary ? "Yes" : "No",
    },
    {
      label: t("NetworkId"),
      text: data?.network,
    },
    {
      label: t("MemberCardId"),
      text: data?.member_card_id,
    },
    {
      label: t("PolicyClassName"),
      text: data?.policy_class,
    },
    {
      label: t("PolicyClassNumber"),
      text: data?.policy_number,
    },
    {
      label: t("PolicyClassHolder"),
      text: data?.policy_holder,
    },
  ];
  return (
    <Panel
      pt={{
        root: { className: "rounded" },
        toggleablecontent: { className: "rounded" },
      }}
    >
      <div className="grid grid-cols-3 lg:grid-cols-5 md:grid-cols-4">
        {rowData?.map((data, index) => (
          <div className="mb-4" key={index}>
            <h5 className="text-12-gray mb-1">{data?.label}</h5>
            <h4 className="text-14-gray !font-semibold">{data?.text}</h4>
          </div>
        ))}
      </div>
    </Panel>
  );
};
